import { render } from "./page-career.vue?vue&type=template&id=57d1e137&scoped=true"
import script from "./page-career.vue?vue&type=script&lang=js"
export * from "./page-career.vue?vue&type=script&lang=js"

import "./page-career.vue?vue&type=style&index=0&id=57d1e137&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d1e137"]])

export default __exports__